import { ImageFormats } from '../types/image-validations';
export const mimeToImageFormat = (mime) => ({
    ['image/jpeg']: ImageFormats.JPEG,
    ['image/jpg']: ImageFormats.JPG,
    ['image/png']: ImageFormats.PNG,
    ['image/webp']: ImageFormats.WEBP,
    ['image/gif']: ImageFormats.GIF,
    ['image/svg+xml']: ImageFormats.SVG,
    ['image/tiff']: ImageFormats.TIFF,
    ['application/pdf']: ImageFormats.PDF,
})[mime];
const getParsedSource = (source) => source instanceof Blob ? new File([source], 'source', { type: source.type }) : source;
export const bytesToMB = (bytes) => {
    return bytes / (1024 * 1024); // 1 MB = 1024 KB = 1024 * 1024 bytes
};
export const getImageDimensions = async (source) => {
    const file = getParsedSource(source);
    const image = new Image();
    image.src = URL.createObjectURL(file);
    await image.decode();
    const width = image.width;
    const height = image.height;
    return { width, height };
};
export const getImageFormat = (source) => {
    const file = getParsedSource(source);
    const sourceFormat = mimeToImageFormat(file.type);
    return sourceFormat || undefined;
};
export const getImageSizeInMb = (source) => {
    const file = getParsedSource(source);
    return bytesToMB(file.size);
};
export const getFileInformation = async (file) => {
    const sizeInMb = getImageSizeInMb(file) || 'UNDEFINED_SIZE_IN_MB';
    const format = file?.type?.split('/')[1] || 'UNDEFINED_FORMAT';
    const dimensions = (await getImageDimensions(file)) || 'UNDEFINED_DIMENSIONS';
    return {
        sizeInMb,
        format,
        dimensions,
    };
};
export const getImageSizeInMegapixels = (width, height) => {
    return (width * height) / 1000000;
};
//# sourceMappingURL=helpers.js.map